import '@backstage/cli/asset-types';
import './components/Root/browserGuards';
import ReactDOM from 'react-dom/client';
import { defineCustomElements } from '@scania/tegel-react';
import app from './App';
import { DrivelineRootErrorBoundary } from './components/common/DrivelineErrorPage';

defineCustomElements();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <DrivelineRootErrorBoundary>{app}</DrivelineRootErrorBoundary>,
);
